import { Paper, styled, Typography } from "@mui/material";
import { StyledButton } from "components/StyledButton";
import { GROUPS_DESCRIPTION } from "messages";
import { useHistory } from "react-router-dom";
import { routes } from "routes";

const PREFIX = "NoGroupsPage";

const classes = {
	button: `${PREFIX}-button`,
	paper: `${PREFIX}-paper`,
};

const StyledPaper = styled(Paper)(({ theme }) => ({
	[`& .${classes.button}`]: {
		marginTop: theme.spacing(5),
	},

	[`&.${classes.paper}`]: {
		padding: theme.spacing(3),
		paddingBottom: theme.spacing(2),
		paddingRight: 0,
		textAlign: "left",
	},
}));

export const NoGroupsPage = (): JSX.Element => {
	const history = useHistory();

	return (
		<StyledPaper className={classes.paper}>
			<Typography variant="h2" data-testid="empty-group">
				My Groups
			</Typography>
			<Typography variant="h4">{GROUPS_DESCRIPTION}</Typography>

			<StyledButton
				variant="contained"
				color="primary"
				className={classes.button}
				data-testid="create-group-btn"
				onClick={() => history.push(routes._.groups._.create.path)}
			>
				Create Group
			</StyledButton>
		</StyledPaper>
	);
};
